import t from 'format-message'

type NavBarMenuItem = {
  path: string
  text: string
}

export const navBarMenuItems = (
  activeAssignmentId: string | undefined,
  isSurvey: boolean,
): NavBarMenuItem[] => {
  const options = [
    {path: `/build/${activeAssignmentId}`, text: t('Build')},
    {path: `/settings/${activeAssignmentId}`, text: t('Settings')},
    {path: `/moderation/${activeAssignmentId}`, text: t('Moderate')},
    {
      path: isSurvey
        ? `/reporting/${activeAssignmentId}/survey_statistics`
        : `/reporting/${activeAssignmentId}`,
      text: t('Reports'),
    },
    {
      path: `/exports/${activeAssignmentId}`,
      text: t('Exports'),
    },
  ]

  return options
}
